import React, { Component } from 'react';
import axios from 'axios';
import '../tools/css/AsistenteConfiguracionInicial.css';

const ApiURL=process.env.REACT_APP_API_URL;

// Las configuraciones mínimas que debe tener un prestador antes de poder
// usar el portal libremente. El endpoint y el destino de cada botón "Crear"
// son los mismos que ya usan Horarios_Atencion.js/Contratos.js/Servicios.js/Convenios.js/Agendas.js
// (ver Listar_horario_atencion, ListaContratos, componentDidMount, Cargar_convenios, CargarAgendas en esos archivos).
const ETAPAS = [
  {
    clave: 'horarios',
    endpoint: '/api/WorkingHours/GetWorkingHours',
    titulo: 'Horarios',
    icono: 'fa-clock',
    descripcionPendiente: 'Configura tu horario de atención y los tiempos de espera de solicitudes para tus citas.',
    tituloPendiente: 'Configura tu horario de atención',
    textoBoton: 'Configurar horario de atención',
    destino: '/horarios?nuevo=true'
  },
  {
    clave: 'contratos',
    endpoint: '/api/Contracts/List',
    titulo: 'Contratos',
    icono: 'fa-file-contract',
    descripcionPendiente: 'Para comenzar a utilizar el portal, necesitas registrar al menos un contrato.',
    tituloPendiente: 'Crea tu primer contrato',
    textoBoton: 'Crear contrato',
    destino: '/contratos?nuevo=true'
  },
  {
    clave: 'servicios',
    endpoint: '/api/Services/ListAll',
    titulo: 'Servicios',
    icono: 'fa-stethoscope',
    descripcionPendiente: 'Registra al menos un servicio para poder continuar con la configuración de tu portal.',
    tituloPendiente: 'Crea tu primer servicio',
    textoBoton: 'Crear servicio',
    destino: '/servicios_facturacion'
  },
  {
    clave: 'consentimientos',
    endpoint: '/api/Consents/List',
    titulo: 'Consentimientos',
    icono: 'fa-file-signature',
    descripcionPendiente: 'Registra al menos un consentimiento informado para poder continuar con la configuración de tu portal.',
    tituloPendiente: 'Crea tu primer consentimiento',
    textoBoton: 'Crear consentimiento',
    destino: '/consentimientos'
  },
  {
    clave: 'convenios',
    endpoint: '/api/Agreements/ListAll',
    titulo: 'Convenios',
    icono: 'fa-handshake',
    descripcionPendiente: 'Registra al menos un convenio para continuar utilizando todas las funcionalidades del portal.',
    tituloPendiente: 'Crea tu primer convenio',
    textoBoton: 'Crear convenio',
    destino: '/convenios?nuevo=true'
  },
  {
    clave: 'agendas',
    endpoint: '/api/Schedules/ListActive',
    titulo: 'Agendas',
    icono: 'fa-calendar-alt',
    descripcionPendiente: 'Crea al menos una agenda para poder gestionar correctamente tus citas y disponibilidad.',
    tituloPendiente: 'Crea tu primera agenda',
    textoBoton: 'Crear agenda',
    destino: '/agendas?nuevo=true'
  }
]

// Rutas que no están atadas a una etapa puntual del asistente pero que el
// usuario puede necesitar visitar para completarlas: no se bloquean con el
// overlay. Perfil (llaves de Wompi) es prerrequisito del paso de Convenios.
// Consentimientos ya queda exento por ser el "destino" de su propia etapa.
const RUTAS_EXENTAS = ['/perfil']

/**
 * Asistente de configuración inicial: mientras el prestador no tenga al menos
 * un registro en Contratos, Servicios, Convenios y Agendas, muestra un overlay
 * de bienvenida a pantalla completa (no descartable) guiándolo paso a paso.
 *
 * Se monta una vez dentro de cada variante de Navbar (el mismo lugar donde ya
 * vive el guardián de sesión de esta app), así que se re-evalúa solo en cada
 * navegación real entre páginas del portal.
 */
class AsistenteConfiguracionInicial extends Component {

  constructor(props) {
    super(props)
    this.state = {
      cargando: true,
      estados: { contratos: false, servicios: false, convenios: false, agendas: false },
      mostrarCompletado: false,
      cerrado: false
    }
  }

  componentDidMount() {
    if (!sessionStorage.getItem('token')) return
    this.verificarConfiguracion()
  }

  /** Trae la data cruda de un endpoint de "listado" y decide si tiene al menos un registro. */
  tieneAlMenosUnRegistro(datos) {
    if (!datos) return false
    const lista = Array.isArray(datos) ? datos : (Array.isArray(datos.data) ? datos.data : null)
    if (!lista) return false
    return lista.length > 0
  }

  verificarConfiguracion() {
    const peticiones = ETAPAS.map((etapa) =>
      axios.get(ApiURL + etapa.endpoint)
        .then((response) => this.tieneAlMenosUnRegistro(response.data))
        .catch((error) => {
          console.log(error)
          return false
        })
    )

    Promise.all(peticiones).then((resultados) => {
      const estados = {}
      ETAPAS.forEach((etapa, indice) => { estados[etapa.clave] = resultados[indice] })

      const completo = ETAPAS.every((etapa) => estados[etapa.clave])

      // El componente se vuelve a montar desde cero en cada navegación (no hay
      // Redux/Context compartido), así que usamos una marca de sesión efímera
      // para saber si en la visita anterior el usuario todavía tenía algo
      // pendiente, y así mostrarle el mensaje de "completado" solo una vez,
      // justo cuando termina el último paso — no cada vez que entra al portal.
      const estabaPendiente = sessionStorage.getItem('asistente_config_pendiente') === 'true'

      if (completo) {
        if (estabaPendiente) {
          sessionStorage.removeItem('asistente_config_pendiente')
          this.setState({ estados, mostrarCompletado: true })
          setTimeout(() => this.setState({ cargando: false, mostrarCompletado: false }), 2200)
        } else {
          this.setState({ estados, cargando: false })
        }
      } else {
        sessionStorage.setItem('asistente_config_pendiente', 'true')
        this.setState({ estados, cargando: false })
      }
    })
  }

  irACompletarEtapa(destino) {
    window.location.href = destino
  }

  render() {
    if (!sessionStorage.getItem('token')) return null

    // Si el usuario ya está en una de las rutas que el propio asistente sugiere
    // (porque hizo clic en "Crear X" o entró directo), no lo tapamos con el
    // overlay — así puede completar la acción sin que el asistente le estorbe.
    const rutaActual = window.location.pathname
    const enRutaDeAsistente = ETAPAS.some((etapa) => etapa.destino.split('?')[0] === rutaActual)
    if (enRutaDeAsistente || RUTAS_EXENTAS.includes(rutaActual)) return null

    if (this.state.cargando && !this.state.mostrarCompletado) return null

    // El overlay es opcional: si el prestador ya lo cerró en esta vista, no
    // se le vuelve a interponer, aunque siga pendiente (se le sigue
    // sugiriendo en la próxima navegación, cuando el componente se remonte).
    if (this.state.cerrado) return null

    const { estados, mostrarCompletado } = this.state
    const totalCompletadas = ETAPAS.filter((etapa) => estados[etapa.clave]).length
    const completo = totalCompletadas === ETAPAS.length

    if (completo && !mostrarCompletado) return null

    const porcentaje = Math.round((totalCompletadas / ETAPAS.length) * 100)
    const siguientePendiente = ETAPAS.find((etapa) => !estados[etapa.clave])

    return (
      <div className="asistente-config__overlay">
        <div className="asistente-config__card">

          {mostrarCompletado ? (
            <div className="asistente-config__completado">
              <div className="asistente-config__completado-icono"><i className="fas fa-check"></i></div>
              <h4>¡Configuración completada!</h4>
              <p>Tu portal está listo. Ya puedes comenzar a utilizar todas sus funcionalidades.</p>
            </div>
          ) : (
            <React.Fragment>

              <div className="asistente-config__header">
                <button type="button" className="asistente-config__cerrar" aria-label="Cerrar" onClick={() => this.setState({ cerrado: true })}>
                  <i className="fas fa-times"></i>
                </button>
                <h4>¡Configura tu portal!</h4>
                <p>Completa estos pasos para comenzar a utilizar todas las funcionalidades de tu cuenta.</p>
              </div>

              <div className="asistente-config__progreso">
                <div className="asistente-config__progreso-barra">
                  <div className="asistente-config__progreso-relleno" style={{ width: porcentaje + '%' }}></div>
                </div>
                <span className="asistente-config__progreso-texto">{totalCompletadas} de {ETAPAS.length}</span>
              </div>

              {siguientePendiente ? (
                <p className="asistente-config__ayuda">
                  {totalCompletadas === 0
                    ? 'Comencemos por lo primero.'
                    : 'Ya vas avanzando. Ahora sigue esto:'} <b>{siguientePendiente.tituloPendiente.toLowerCase()}</b>.
                </p>
              ) : null}

              <div className="asistente-config__etapas">
                {ETAPAS.map((etapa) => {
                  const completada = estados[etapa.clave]
                  return (
                    <div className={"asistente-config__etapa" + (completada ? " asistente-config__etapa--completa" : "")} key={etapa.clave}>
                      <span className="asistente-config__etapa-icono">
                        {completada ? <i className="fas fa-check"></i> : <i className={"fas " + etapa.icono}></i>}
                      </span>
                      <div className="asistente-config__etapa-texto">
                        <span className="asistente-config__etapa-titulo">{etapa.titulo}</span>
                        <span className="asistente-config__etapa-desc">
                          {completada ? 'Configurado correctamente' : etapa.descripcionPendiente}
                        </span>
                        {!completada ? (
                          <button type="button" className="asistente-config__etapa-btn" onClick={() => this.irACompletarEtapa(etapa.destino)}>
                            {etapa.textoBoton}
                          </button>
                        ) : null}
                      </div>
                    </div>
                  )
                })}
              </div>

            </React.Fragment>
          )}

        </div>
      </div>
    )
  }
}

export default AsistenteConfiguracionInicial;
